import { Input as BaseInput, InputProps } from 'antd';
import style from './index.module.scss';
import Paragraph from 'antd/lib/typography/Paragraph';

type TInput = {
  inputType?: 'primary' | 'secondary';
  label: string;
  iconRender?: (visible: boolean) => void;
} & InputProps;

export const Input = ({
  inputType = 'primary',
  label,
  iconRender,
  ...props
}: TInput) => {
  return (
    <div
      className={`${style.container} ${style[inputType]} ${
        props.className || ''
      }`}
    >
      {(iconRender && (
        <BaseInput.Password {...props} className={`${style.input}`} />
      )) || <BaseInput {...props} className={`${style.input}`} />}
      <Paragraph className={style.label}>{label}</Paragraph>
    </div>
  );
};
